import { instance2 } from './base';

export const getProfile = () =>
    instance2
        .get('/api/v1/profile')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const updProfile = (userID, data) =>
    instance2
        .patch('/api/v1/profile', data, {})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const signUp = (data) =>
    instance2
        .post('/api/v1/registration', data, {})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
